import { dataLayerPush } from '@libs/analytics';

type TrackFooterClick = {
    selection: string;
    link_url: string;
};

export const trackFooterClick = ({ selection, link_url }: TrackFooterClick) => {
    dataLayerPush({
        event: 'nav_click',
        nav_section: 'footer nav',
        selection,
        link_url,
    });
};
